var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuckTextMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2193.623,
    height: 323.876,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-454.944 1160.91h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-656.561 1038.824h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1006.554 1038.824h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1064.476 1038.824h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1384.171 1038.824h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1443.654 1133.506h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1663.094 1133.506h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-258.333 1009.328h2000v-2000h-2000Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-345.926 1062.74h2000v-2000h-2000Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-1.931.965-2.896 2.896-2.896H75.97c6.534 0 12.031.593 16.486 1.783 4.456 1.186 8.055 3.119 10.805 5.793 2.747 2.673 4.713 6.237 5.904 10.693 1.187 4.456 1.783 9.948 1.783 16.485v24.507c0 6.534-.596 12.031-1.783 16.486-1.191 4.456-3.157 8.021-5.904 10.694-2.75 2.674-6.349 4.602-10.805 5.793-4.455 1.187-9.952 1.781-16.486 1.781H2.896C.965 91.119 0 90.079 0 88.002Zm76.861 122.086c12.031 0 22.352-1.224 30.967-3.676 8.612-2.45 15.668-6.236 21.165-11.362 5.493-5.123 9.541-11.661 12.142-19.605 2.596-7.946 3.898-17.341 3.898-28.182V28.963c0-10.843-1.302-20.239-3.898-28.183-2.601-7.947-6.649-14.481-12.142-19.605-5.497-5.123-12.553-8.912-21.165-11.362-8.615-2.45-18.936-3.676-30.967-3.676H-27.402c-4.456 0-6.684 2.228-6.684 6.684v142.583c0 4.456 2.228 6.682 6.684 6.682z",
    clipPath: "url(#a)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 370.07 235.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.265 0 4.901-1.636 4.901-4.9v-88.893c0-5.941.48-10.88 1.448-14.814.964-3.937 2.562-7.056 4.79-9.358 2.228-2.303 5.236-3.937 9.023-4.9 3.787-.968 8.577-1.449 14.369-1.449h61.712c5.793 0 10.582.481 14.37 1.449 3.787.963 6.794 2.597 9.022 4.9 2.228 2.302 3.788 5.421 4.679 9.358.891 3.934 1.337 8.873 1.337 14.814V-4.9c0 3.264 1.632 4.9 4.901 4.9h24.284c3.265 0 4.901-1.636 4.901-4.9v-92.234c0-10.693-1.114-19.793-3.342-27.291-2.228-7.502-5.831-13.59-10.805-18.268-4.978-4.678-11.438-8.059-19.382-10.137-7.948-2.081-17.565-3.119-28.851-3.119H33.195c-11.289 0-20.869 1.038-28.74 3.119-7.874 2.078-14.296 5.459-19.27 10.137-4.979 4.678-8.616 10.766-10.917 18.268-2.305 7.498-3.453 16.598-3.453 27.291V-4.9c0 3.264 1.706 4.9 5.124 4.9z",
    clipPath: "url(#b)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 638.893 72.335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.265 0 4.901-1.636 4.901-4.9v-21.833c0-3.418-1.636-5.125-4.901-5.125h-99.139c-5.793 0-10.583-.483-14.371-1.448-3.786-.968-6.794-2.6-9.022-4.9-2.228-2.305-3.826-5.387-4.79-9.247-.968-3.864-1.448-8.765-1.448-14.703v-31.637c0-5.941.48-10.88 1.448-14.814.964-3.937 2.562-7.056 4.79-9.358 2.228-2.303 5.236-3.937 9.022-4.9 3.788-.968 8.578-1.449 14.371-1.449H0c3.265 0 4.901-1.636 4.901-4.9v-21.833c0-3.27-1.636-4.902-4.901-4.902h-100.476c-11.29 0-20.869 1.038-28.74 3.119-7.873 2.078-14.296 5.459-19.27 10.137-4.978 4.678-8.616 10.766-10.917 18.268-2.305 7.498-3.453 16.598-3.453 27.291v38.319c0 10.695 1.148 19.752 3.453 27.18 2.301 7.425 5.939 13.479 10.917 18.158 4.974 4.678 11.397 8.092 19.27 10.247 7.871 2.151 17.45 3.23 28.74 3.23z",
    clipPath: "url(#c)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1105.55 72.335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.266 0 4.902-1.636 4.902-4.9v-59.261h31.413c3.565 0 6.534.111 8.912.333 2.374.224 4.455.704 6.237 1.448a17.165 17.165 0 0 1 4.902 3.119c1.484 1.337 3.042 3.043 4.678 5.126L99.365-2.896c.74 1.038 1.481 1.783 2.226 2.228.742.446 2.151.668 4.234.668h27.624c1.929 0 3.082-.633 3.454-1.893.369-1.264.184-2.416-.557-3.453l-43.22-55.919c-2.527-3.418-4.868-6.315-7.019-8.688-2.154-2.379-4.27-4.457-6.347-6.239 5.791-3.565 11.433-8.91 16.931-16.04l45.67-57.924c.593-.746.815-1.893.668-3.454-.149-1.559-1.335-2.339-3.563-2.339h-28.517c-1.933 0-3.27.222-4.011.668-.744.445-1.485 1.188-2.228 2.228l-40.992 53.024c-2.973 3.86-6.166 6.494-9.58 7.908-3.418 1.41-8.542 2.117-15.373 2.117H4.902v-61.043c0-3.27-1.636-4.902-4.902-4.902h-24.06c-3.418 0-5.124 1.632-5.124 4.902V-4.9c0 3.264 1.706 4.9 5.124 4.9z",
    clipPath: "url(#d)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1182.78 72.335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.415 0 5.124-1.636 5.124-4.9v-21.165c0-3.268-1.709-4.902-5.124-4.902h-96.69c-5.791 0-10.582-.483-14.369-1.448-3.788-.968-6.795-2.6-9.023-4.9-2.228-2.305-3.826-5.424-4.79-9.358-.967-3.937-1.448-8.799-1.448-14.592v-4.456H-1.115c3.266 0 4.902-1.636 4.902-4.902v-17.599c0-3.269-1.636-4.901-4.902-4.901H-126.32v-57.924c0-3.27-1.636-4.902-4.902-4.902h-24.059c-3.42 0-5.126 1.632-5.126 4.902v92.232c0 10.695 1.149 19.752 3.454 27.18 2.302 7.425 5.938 13.479 10.917 18.158 4.975 4.678 11.396 8.092 19.27 10.247C-118.895-1.079-109.315 0-98.027 0z",
    clipPath: "url(#e)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1609.04 72.335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.793.481-10.66 1.448-14.594.964-3.937 2.562-7.055 4.791-9.356 2.228-2.305 5.234-3.937 9.023-4.902 3.786-.968 8.577-1.448 14.368-1.448h66.169c5.791 0 10.582.48 14.368 1.448 3.787.965 6.796 2.597 9.024 4.902 2.228 2.301 3.822 5.419 4.789 9.356.964 3.934 1.449 8.801 1.449 14.594v33.417c0 5.793-.485 10.655-1.449 14.593-.967 3.933-2.561 7.052-4.789 9.357-2.228 2.3-5.237 3.932-9.024 4.9-3.786.965-8.577 1.448-14.368 1.448H29.63c-5.791 0-10.582-.483-14.368-1.448-3.789-.968-6.795-2.6-9.023-4.9-2.229-2.305-3.827-5.424-4.791-9.357C.481 44.072 0 39.21 0 33.417Zm97.136 94.682c11.285 0 20.902-1.079 28.85-3.23 7.944-2.155 14.404-5.569 19.381-10.247 4.975-4.678 8.578-10.732 10.806-18.158 2.228-7.428 3.341-16.485 3.341-27.18V-2.452c0-10.693-1.113-19.793-3.341-27.291-2.228-7.502-5.831-13.59-10.806-18.268-4.977-4.678-11.437-8.059-19.381-10.136-7.948-2.082-17.565-3.12-28.85-3.12H28.293c-11.288 0-20.868 1.038-28.739 3.12-7.874 2.077-14.295 5.458-19.27 10.136-4.978 4.678-8.615 10.766-10.917 18.268-2.304 7.498-3.453 16.598-3.453 27.291v38.319c0 10.695 1.149 19.752 3.453 27.18 2.302 7.426 5.939 13.48 10.917 18.158 4.975 4.678 11.396 8.092 19.27 10.247 7.871 2.151 17.451 3.23 28.739 3.23z",
    clipPath: "url(#f)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1688.35 198.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-5.793.481-10.66 1.448-14.594.964-3.937 2.562-7.055 4.791-9.356 2.228-2.305 5.234-3.937 9.023-4.902 3.786-.968 8.577-1.448 14.368-1.448h66.169c5.791 0 10.582.48 14.368 1.448 3.787.965 6.796 2.597 9.024 4.902 2.228 2.301 3.822 5.419 4.788 9.356.965 3.934 1.45 8.801 1.45 14.594v33.417c0 5.793-.485 10.655-1.45 14.593-.966 3.933-2.56 7.052-4.788 9.357-2.228 2.3-5.237 3.932-9.024 4.9-3.786.965-8.577 1.448-14.368 1.448H29.63c-5.791 0-10.582-.483-14.368-1.448-3.789-.968-6.795-2.6-9.023-4.9-2.229-2.305-3.827-5.424-4.791-9.357C.481 44.072 0 39.21 0 33.417Zm97.135 94.682c11.286 0 20.903-1.079 28.851-3.23 7.944-2.155 14.404-5.569 19.381-10.247 4.975-4.678 8.577-10.732 10.805-18.158 2.229-7.428 3.342-16.485 3.342-27.18V-2.452c0-10.693-1.113-19.793-3.342-27.291-2.228-7.502-5.83-13.59-10.805-18.268-4.977-4.678-11.437-8.059-19.381-10.136-7.948-2.082-17.565-3.12-28.851-3.12H28.293c-11.288 0-20.868 1.038-28.739 3.12-7.874 2.077-14.295 5.458-19.27 10.136-4.979 4.678-8.615 10.766-10.917 18.268-2.304 7.498-3.453 16.598-3.453 27.291v38.319c0 10.695 1.149 19.752 3.453 27.18 2.302 7.426 5.938 13.48 10.917 18.158 4.975 4.678 11.396 8.092 19.27 10.247 7.871 2.151 17.451 3.23 28.739 3.23z",
    clipPath: "url(#g)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 1980.938 198.578)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.473 24.756s9.878-5.882 17.067-14.08c0 0-21.12 4.693-39.466-8.533 0 0 6.552.507 11.926-2.143 0 0-22.592-20.333-17.258-49.796 1.48-8.171 5.169-15.755 10.174-22.381C-2.981-77.61 3.375-84.83 12.46-92.13c0 0-24.264-4.262-30.534-24.59 0 0-12.064 3.428-24.89 10.961-14.952 8.782-34.235.348-37.149-16.746a60.497 60.497 0 0 1-.296-1.922c-.93-6.797-.613-13.707.733-20.434 3.322-16.593 14.246-50.014 49.343-65.14 6.518-2.808 13.413-4.597 20.424-5.703 27.892-4.403 114.409-11.597 121.842 66.827 0 0 5.065 44.536-27.292 65.277 0 0-14.585 8.686-10.106 21.687.89 2.582 2.507 4.848 4.489 6.725 6.18 5.853 22.327 20.212 5.203 44.805 0 0-20.208 29.805-73.754 35.139zm54.003-41.93c2.527-.002 5.438-1.697 7.442-4.602 2.787-4.042 2.76-8.897-.06-10.842-2.82-1.944-7.366-.244-10.153 3.799-2.788 4.042-2.762 8.896.058 10.84.794.548 1.724.806 2.713.805zm-.034-97.988s4.613-12.582.964-25.832c-3.417-12.407-14.681-21.022-27.54-21.547-11.976-.489-29.448 2.533-42.618 20.474a1.234 1.234 0 0 0 .1 1.572l.38.4c.505.533 1.36.51 1.83-.054l.132-.158c19.114-22.673 55.993-15.14 64.604 13.238 1.08 3.562 1.844 7.521 2.148 11.907z",
    clipPath: "url(#h)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 107.922 33.008)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.975-4.885-6.939-11.135-6.939-11.135C-8.692-22.734 3.304-23.749 3.304-23.749c22.559-.305 27.32 6.631 27.32 6.631 5.476 6.279-8.435 10.484-8.435 10.484C40.798 6.88 38.585 21.65 38.585 21.65c-1.003 4.924-4.272 5.601-6.775 5.333-1.664-.179-3.152-1.042-4.303-2.256-6.32-6.669-16.578-6.096-16.578-6.096S9.307 10.547 0 0",
    clipPath: "url(#i)",
    style: {
      fill: "#9CA3AF",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 224.713 104.224)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuckTextMono);
export default __webpack_public_path__ + "static/media/duck_text_mono.1f2dfae36b1bd486c8306603dfbd2734.svg";
export { ForwardRef as ReactComponent };